module.exports = __webpack_public_path__ + "static/media/biceps-curls.28d2e6f6.jpg";